import { useToast } from './useToast';
import { Toast } from './Toast';

export const Toaster = () => {
  const { toasts } = useToast();

  return (
    <>
      {toasts.map((toastItem) => (
        <Toast
          key={toastItem.id}
          id={toastItem.id}
          title={toastItem.title}
          description={toastItem.description}
          variant={toastItem.variant}
          severity={toastItem.severity}
          open={toastItem.open}
          autoHideDuration={toastItem.autoHideDuration}
          onClose={() => toastItem.onOpenChange?.(false)}
        />
      ))}
    </>
  );
};
